htmx.config.defaultSwapDelay = 200;

function getSkeletonElement(triggerElement, boosted) {
    const skeletonSelector = triggerElement?.dataset?.skeleton ?? (boosted ? "#page-content-skeleton" : "#default-skeleton");
    return document.querySelector(skeletonSelector);
}

document.body.addEventListener('htmx:beforeRequest', function (event) {
    let target = event.detail.target;
    if (!target) return;

    const elt = event.target;
    const swap = (elt ? elt.getAttribute('hx-swap') : null) || 'innerHTML';
    if (swap === 'none') return;

    const skeleton = getSkeletonElement(event.detail.elt, event.detail.boosted);
    if (!skeleton) return;

    while (target.firstChild) target.removeChild(target.firstChild);

    let cloneFragment = skeleton.content.cloneNode(true);
    target.appendChild(cloneFragment);
});

document.body.addEventListener('htmx:beforeSwap', function (event) {
    if (event.detail.boosted || event.target.id === 'mainContent') {
        event.detail.selectOverride = '#mainContent';
        document.querySelector('.bg-dark-backdrop\\/70.fixed.inset-0.z-40')?.remove();
    }
});


